import { useQuery } from '@tanstack/react-query';

import { getConversationInventory } from '../services/inventory-service';

export const QUERY_KEY_CONVERSATION_INVENTORY = 'conversation-inventory';

export const useConversationInventory = (
  conversationId: string,
  enabled: boolean
) =>
  useQuery({
    queryKey: [QUERY_KEY_CONVERSATION_INVENTORY, conversationId],
    queryFn: () => getConversationInventory(conversationId),
    enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
